var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0908 5.25C10.3148 5.25 10.5253 5.33767 10.6846 5.49902L16.502 11.3936C16.6615 11.5553 16.75 11.7701 16.75 12C16.75 12.2298 16.6615 12.4438 16.502 12.6055L10.6846 18.501C10.5248 18.6626 10.3145 18.75 10.0908 18.75C9.86734 18.75 9.65779 18.6623 9.49805 18.501C9.33846 18.3392 9.25 18.1244 9.25 17.8945C9.25005 17.6647 9.33758 17.4497 9.49707 17.2881L14.5439 12.1758L14.7178 12L14.5439 11.8242L9.49805 6.71094C9.33856 6.54929 9.25007 6.33522 9.25 6.10547C9.25 5.87561 9.33852 5.66072 9.49805 5.49902C9.65724 5.33785 9.86709 5.25002 10.0908 5.25Z",
    fill: "white",
    stroke: "#E4E6EB",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRt);
export default __webpack_public_path__ + "static/media/arrow_rt.4c5ae09a4bc10bd0cdc568a49609d124.svg";
export { ForwardRef as ReactComponent };